import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

// TO DO: ADO WI 459627 - Remove this function and calls to it so the win32 style icons and buttons
// always appear in the search bar, independently of the Win32 styling setting.
export function isSearchBoxWin32ParityEnabled(): boolean {
    return isWin32StylingEnabled();
}
